var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaytm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-148 32.5 484 484",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M230 243l4-3c14-12 32-10 43 4h3l3-3c9-9 22-11 33-6 12 5 19 15 19 28v86c0 10-6 16-17 16l-12 1c-4 0-5-1-5-6v-84-3c0-7-2-9-9-10-5 0-9 3-10 9v77c0 10-6 16-16 16-6 0-13 3-16-1-3-3-1-10-1-15v-75c0-8-6-13-13-10-5 2-6 6-6 10v75c-1 10-7 16-16 16h-12c-5 1-6 0-6-5V242v-5c0-2 1-3 3-3h28c2 0 3 1 3 3v6z",
    fill: "#02b9ef"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 297v41c0 18-10 27-27 27l-24 1c-16-1-27-11-28-27v-34c1-16 13-28 29-28h13c5 0 6-2 6-6s-2-6-6-6h-13c-11 0-17-6-17-17 0-4-2-10 1-13 2-2 8-1 12-1h34c12 0 20 8 20 20v43zm-31 23v-5c0-10 0-10-10-10-5 1-8 3-8 8v13c0 7 3 9 14 9 7 1 3-5 4-8v-7z",
    fill: "#06306f"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M107 287v46c0 11-3 22-15 28-4 3-9 4-15 4l-34 1c-3 0-3-1-3-4v-12c0-8 6-15 14-15h16c4 0 6-2 6-6 0-5-2-6-6-6-7-1-14 0-21-2-12-3-21-13-21-25v-59c0-2 0-3 3-3h24c4 0 3 2 3 5v44c0 6 3 9 9 10 6 0 9-3 9-10v-44c0-4 1-5 5-5h22c4 0 4 2 4 5v48zM-148 309v-49c0-16 10-26 26-26 10 0 21-1 31 1 14 3 22 13 22 27v43c0 19-11 30-29 30h-16c-3 0-4 1-4 4v12c0 8-6 14-15 14-5 0-11 2-14 0-3-3-1-10-1-14v-42zm30-24v9c0 11 0 11 12 10 4 0 7-2 7-7v-17c0-16-3-15-16-15-2 0-3 1-3 3v17z",
    fill: "#06306f"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M135 309v-40c0-3-1-4-4-4-4 0-10 2-13-1s-1-9-1-14v-1c0-4-1-10 1-13s8-2 12-3c8-2 15-7 20-14 4-4 8-7 14-9 3 0 5 0 5 4v17c0 3 0 3 3 3h12c2 0 3 1 3 3v25c0 2-1 4-3 3h-2c-4 1-10-2-12 1-3 3-1 9-1 13v82c0 4-1 5-5 5l-11-1c-11 0-18-7-18-18v-38z",
    fill: "#02b9ef"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaytm);
export default __webpack_public_path__ + "static/media/paytm.4f8412092ed275baeac0ff460c1dea97.svg";
export { ForwardRef as ReactComponent };